require('./disclaimer-component.scss');

riot.tag2('disclaimer-component', '<div class="disclaimer-container"> <span class="disclaimer-label">{getLabel(\'disclaimer.description\')}</span> </div>', '', 'show="{disclaimer}"', function(opts) {
});
